import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { commitHash } from '@paragon/client-tools';
import { LAYOUT_MODEL_SYNCHRONIZED_ACTIONS } from '@paragon/layout-models';
import {
  attemptAutomaticLogInWithStoredToken,
  initializeDataConnectionsAndLoginTools,
  isG2User,
} from '@paragon/login-tools';
import { makeIdSafe } from '@paragon/sync-client';
import { ParagonThemeProvider } from '@paragon/themes';

import g2FaviconUrl from '../resources/G2Favicon.ico';
import RootComponent from './components/RootComponent';
import startUp from './store/actions/startUp';
import { store, syncClient } from './store/slices';
import { chTheme, darkTheme, g2Theme, lightTheme } from './themes';

if (commitHash != null) console.log(`Commit hash: ${commitHash}`);

initializeDataConnectionsAndLoginTools(store);

async function loginAndStartApp() {
  const user = await store.dispatch(attemptAutomaticLogInWithStoredToken());
  switchFaviconForOrganization();
  if (user) {
    store.dispatch(startUp());
    initializeSynchronization(user.organization);
  }
}

function initializeSynchronization(organization: string) {
  syncClient.whenReady.then(() => {
    syncClient.state.store = store;

    syncClient.state.configurations = [
      {
        room: `#projects-${makeIdSafe(organization)}`,
        synchronizedActions: [...LAYOUT_MODEL_SYNCHRONIZED_ACTIONS],
      },
    ];
  });
}

const switchFaviconForOrganization = () => {
  const { getState } = store;
  if (isG2User(getState())) {
    const link: any = document.querySelector("link[rel*='shortcut icon']") || document.createElement('link');
    link.type = 'image/png';
    link.rel = 'shortcut icon';
    link.href = g2FaviconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
};

loginAndStartApp();

const root = createRoot(document.querySelector('.root-anchor')!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ParagonThemeProvider
        darkTheme={darkTheme}
        lightTheme={lightTheme}
        g2Theme={g2Theme}
        chTheme={chTheme}
        trussWorksTheme={darkTheme}
      >
        <RootComponent />
      </ParagonThemeProvider>
    </Provider>
  </React.StrictMode>,
);
